import { render } from "./ChooseStation.vue?vue&type=template&id=64481505&scoped=true"
import script from "./ChooseStation.vue?vue&type=script&lang=js"
export * from "./ChooseStation.vue?vue&type=script&lang=js"

import "./ChooseStation.vue?vue&type=style&index=0&id=64481505&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64481505"]])

export default __exports__